// extracted by mini-css-extract-plugin
export default {"item":"CompanyInfoSection_item__B2bew","action":"CompanyInfoSection_action__lAtUp","wrapper":"CompanyInfoSection_wrapper__2knKb","info":"CompanyInfoSection_info__joRd3"};